import { motion } from 'framer-motion'
import { FiGithub, FiLinkedin, FiMail, FiFacebook, FiInstagram } from 'react-icons/fi'
import LogoImage from "../assets/bg5.png";
import { Link } from 'react-scroll'
const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: FiGithub,
      href: "https://github.com/Jivan-Dahal",
      label: "GitHub",
      color: "text-[#181717] hover:text-[#0f0f0f] dark:text-white" // GitHub Black
    },
    {
      icon: FiLinkedin,
      href: "https://www.linkedin.com/in/jivan-dahal-611372334/",
      label: "LinkedIn",
      color: "text-[#0077B5] hover:text-[#005582]" // LinkedIn Blue
    },
    {
      icon: FiMail,
      href: "mailto:dahaljivan02@gmail.com",
      label: "Email",
      color: "text-[#D44638] hover:text-[#a3332a]" // Gmail Red
    },
    {
      icon: FiFacebook,
      href: "https://www.facebook.com/jivandahal2",
      label: "Facebook",
      color: "text-[#1877F2] hover:text-[#0f5dc8]" // Facebook Blue
    },
    {
      icon: FiInstagram,
      href: "https://www.instagram.com/jivan_dahal__",
      label: "Instagram",
      color: "text-[#E4405F] hover:text-[#c32e4a]" // Instagram Pink
    }
  ];

  const menuItems = [
    { title: 'Home', to: 'home' },
    { title: 'About', to: 'about' },
    // { title: 'Experience', to: 'experience' },
    { title: 'Skills', to: 'skills' },
    { title: 'Projects', to: 'projects' },
    { title: 'Contact', to: 'contact' },
  ]

  return (
    <footer className="relative bg-gradient-to-b from-gray-50 to-gray-100  dark:from-gray-900 dark:to-gray-800 border-t  border-indigo-800 dark:border-gray-700">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Logo & Mission */}
          <div className="md:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="flex flex-col space-y-4"
            >
              <div className="flex items-center">
                <img src={LogoImage} alt="Logo" className="h-12 w-auto mr-3" />
                
              </div>
              <p className="text-gray-600 font-mono text-justify dark:text-gray-300 text-sm mt-3 leading-relaxed">
                Transforming ideas into elegant digital experiences. Specialized in web development,
                UI/UX design, and creative problem-solving.
              </p>
            </motion.div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-4 md:mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <h3 className="text-gray-900 font-robotoMono dark:text-white font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                {menuItems.map((item, index) => (
                  <li key={index}>
                    <Link
                      key={item.to}
                      to={item.to}
                      spy={true}
                      smooth={true}
                      offset={-64}
                      className="text-gray-700 font-montserrat font-semibold  dark:text-gray-200 hover:text-primary dark:hover:text-primary px-3 py-2 rounded-md text-sm cursor-pointer"
                    >
                      {item.title}
                    </Link>

                  </li>
                ))}
              </ul>
            </motion.div>
          </div>

          {/* Social Links */}
          <div className="md:col-span-3">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h3 className="text-gray-900 font-robotoMono dark:text-white font-bold mb-4">Connect</h3>
              <div className="flex space-x-5">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    whileHover={{ scale: 1.1, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                    transition={{ type: "spring", stiffness: 400 }}
                    className={` ${social.color}  rounded-circle  italic  transition duration-300`}
                    aria-label={social.label}
                  >
                    <social.icon className="w-6 h-6" />
                  </motion.a>
                ))}
              </div>
              <p className="text-gray-500 text-nowrap font-mono dark:text-gray-200 text-sm mt-4">
                Let's connect and discuss your next project
              </p>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-indigo-800 dark:border-gray-700 py-4 bg-white dark:bg-gray-800 bg-opacity-80 backdrop-filter backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm font-montserrat font-semibold text-gray-800 dark:text-gray-200">
              © {currentYear} <span className="font-bold text-primary dark:text-yellow-500">Jivan Dahal</span>. All rights reserved.
            </p>
            <p className="text-sm font-semibold font-montserrat text-gray-800 dark:text-gray-200 mt-1 md:mt-0">
              Designed & Developed with passion
            </p>
          </div>
        </div>
      </div>

      {/* Accent Line */}
      <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-primary via-secondary to-primary"></div>
    </footer>
  );
};

export default Footer;